var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-btn',{staticClass:"my-5",attrs:{"block":"","color":"green lighten-2","dark":""},on:{"click":_vm.tomarFoto}},[_vm._v(" FOTO")]),_c('input',{ref:"camera",staticStyle:{"visibility":"hidden","display":"none"},attrs:{"id":"camera","type":"file","accept":"image/*","capture":"camera"},on:{"change":_vm.onChangeFoto}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }